var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tips_container",on:{"click":_vm.clickHandle}},[_c('i',{staticClass:"icon"}),_c('span',{staticClass:"txt"},[_vm._v("我的订单")])])}
var staticRenderFns = []

export { render, staticRenderFns }